import React from 'react';

// Gemeinsamer Escape-Handler fuer alle Brokerage-Dialoge (Login, TAN,
// Order-Formular, Verbindungs-/Depot-Auswahl) - ruft onClose auf, wenn ESC
// gedrueckt wird, waehrend der jeweilige Dialog sichtbar ist.
export default function useEscapeToClose(onClose) {
	React.useEffect(() => {
		if (!onClose) return;
		function handleKeyDown(e) {
			if (e.key === 'Escape') onClose();
		}
		document.addEventListener('keydown', handleKeyDown);
		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [onClose]);
}
